const INTERNAL_FIELDS = ['_validate_user', '_val_ts', '_form_id', 'frc-captcha-response'];

class ExternalActionForm {
    constructor(form) {
        this.form = form;
        this.actionUrl = form.dataset.actionUrl;
        this.ajaxUrl = form.dataset.ajaxUrl;
        this.submitButton = form.querySelector('[type="submit"]');

        form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    handleSubmit(e) {
        e.preventDefault();

        const verifyData = new FormData();
        const getVal = (name) => {
            const el = this.form.querySelector('[name="' + name + '"]');
            return el ? el.value : '';
        };

        verifyData.append('action', 'verify_captcha_external');
        verifyData.append('_validate_user', getVal('_validate_user'));
        verifyData.append('_val_ts', getVal('_val_ts'));
        verifyData.append('_form_id', getVal('_form_id'));
        verifyData.append('frc-captcha-response', getVal('frc-captcha-response'));

        if (this.submitButton) this.submitButton.disabled = true;

        fetch(this.ajaxUrl, {
            method: 'POST',
            body: verifyData,
        })
            .then((response) => response.json())
            .then((result) => {
                if (!result.valid) {
                    this.showError(result.message);
                    if (this.submitButton) this.submitButton.disabled = false;
                    return;
                }

                INTERNAL_FIELDS.forEach((name) => {
                    const el = this.form.querySelector('[name="' + name + '"]');
                    if (el) el.remove();
                });

                this.form.action = this.actionUrl;
                this.form.submit();
            })
            .catch(() => {
                this.showError();
                if (this.submitButton) this.submitButton.disabled = false;
            });
    }

    showError(message) {
        const existing = this.form.querySelector('.js-external-form-error');
        if (existing) existing.remove();

        const error = document.createElement('p');
        error.className = 'message message--error js-external-form-error';
        error.textContent = message || 'Beim Senden des Formulars ist ein Fehler aufgetreten. Bitte versuche es erneut.';
        this.form.prepend(error);
    }
}

const externalActionForm = {
    init() {
        document.querySelectorAll('.js-external-action-form').forEach((form) => {
            new ExternalActionForm(form);
        });
    },
};

export default externalActionForm;
